import PropTypes from 'prop-types'
import { Element } from '../html/element'
import { Notification } from '../notification'

export const NoData = ({
  height,
  colSpan,
  value,
  isCenterNoData,
  noDataPaddingTop,
}) => {
  return (
    <tbody>
      <tr>
        <Element
          elementName="td"
          colSpan={colSpan}
          style={{ height, backgroundColor: '#F3F3F3' }}
        >
          <div className="h100">
            {isCenterNoData ? (
              <Notification value={value} />
            ) : (
              <div style={{ paddingTop: noDataPaddingTop }}>
                <Notification value={value} />
              </div>
            )}
          </div>
        </Element>
      </tr>
    </tbody>
  )
}

NoData.propTypes = {
  height: PropTypes.number.isRequired,
  colSpan: PropTypes.number,
  value: PropTypes.string,
  isCenterNoData: PropTypes.bool,
  noDataPaddingTop: PropTypes.number,
}

NoData.defaultProps = {
  colSpan: 1,
  value: 'common.NO_DATA',
  isCenterNoData: true,
  noDataPaddingTop: 80,
}
